/**
 * FRONT-3223 (eddy, 2026-10-28): the chat's start time ("started 14:02") is
 * the first line of the conversation only once the person has written in it;
 * an untouched chat shows no start time. Pure, because the window's messages
 * arrive through an effect a static render never runs.
 */
export function showStartLine(messages: ReadonlyArray<{ role: string }>): boolean {
  return messages.some((m) => m.role === 'user');
}

/** Before anything is said, the reply box sits mid-window (`useCenterLift`). */
export function isEmptyConversation(messages: ReadonlyArray<unknown>, historyLoading: boolean): boolean {
  return messages.length === 0 && !historyLoading;
}
